// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"cf2f246c","457":"acaeb591","551":"628942f0","940":"6c4ef7f6"}[chunkId] + ".chunk.js";
};